<div class="container row">
  <app-config-line [title]="'Preferencias panel de Eventos'" [titleLevel]="7" [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES" [render]="!filterOptionsBy">
  </app-config-line>

  <!-- ================= FILTRO DE EVENTOS ================= -->
  <app-config-line [title]="'Filtro de eventos'"
    [description]="'Muestra u oculta el selector múltiple de eventos en el panel.'" [filterBy]="filterOptionsBy">
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input type="checkbox" [(ngModel)]="eventService.config.showEventSelector" />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line [title]="'Eventos seleccionado'"
    [description]="'Elige los eventos que deseas visualizar en la tabla de eventos.'" [filterBy]="filterOptionsBy">
    <p-multiSelect [options]="eventService.eventsGroupedList" [group]="true"
      [(ngModel)]="eventService.config.eventsSelected" optionLabel="name"
      [defaultLabel]="'EVENTS.LABELS.NO_EVENTS_SELECTED' | translate"
      [selectedItemsLabel]="'{0} ' + ('EVENTS.LABELS.SELECTED_EVENTS' | translate)" [showToggleAll]="true"
      scrollHeight="250px" [appendTo]="'body'" class="fixed-width-multiselect" [maxSelectedLabels]="1">
      <ng-template let-group pTemplate="group">
        <div class="p-d-flex p-ai-center">
          <span>{{ group.label }}</span>
        </div>
      </ng-template>
    </p-multiSelect>
  </app-config-line>

  <!-- ================= FILTRO DE AGRUPACION ================= -->

  <app-config-line [title]="'Filtro de Agrupación'"
    [description]="'Activa o desactiva la visualización del filtro de agrupación.'" [filterBy]="filterOptionsBy">
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input type="checkbox" [(ngModel)]="eventService.config.showGroupingSelector" />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line [title]="'Agrupación seleccionada'"
    [description]="'Escoge la operación, grupo y/o convoy para acotar los vehículos.'" [filterBy]="filterOptionsBy">
    <div class="row w-100 m-0">
      <div class="col-sm-4 p-field mb-2">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Operación:</label>
        <p-dropdown [options]="operations" [(ngModel)]="selectedOperation" [showClear]="true"
          optionLabel="nameoperation" optionValue="idoperation" (onChange)="onChangeOperation()"
          [placeholder]="placeholderOperation" [disabled]="disabledOperation" styleClass="w-full"
          [style]="{'width': '100%'}" appendTo="body"></p-dropdown>
      </div>
      <div class="col-sm-4 p-field mb-2">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Grupo:</label>
        <p-dropdown [options]="groups" [(ngModel)]="selectedGroup" [showClear]="true" optionLabel="namegrupo"
          optionValue="idgrupo" (onChange)="onChangeGroup()" [placeholder]="placeholderGroup" [disabled]="disabledGroup"
          styleClass="w-full" [style]="{'width': '100%'}" appendTo="body"></p-dropdown>
      </div>
      <div class="col-sm-4 p-field mb-2">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Convoy:</label>
        <p-dropdown [options]="convoys" [(ngModel)]="selectedConvoy" [showClear]="true" optionLabel="nameconvoy"
          optionValue="idconvoy" (onChange)="onChangeConvoy()" [placeholder]="placeholderConvoy"
          [disabled]="disabledConvoy" styleClass="w-full" [style]="{'width': '100%'}" appendTo="body"></p-dropdown>
      </div>
    </div>
  </app-config-line>

  <app-config-line [title]="'Filtro de Vehículos'"
    [description]="'Activa o desactiva la visualización del filtro de vehículos.'" [filterBy]="filterOptionsBy">
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input type="checkbox" [(ngModel)]="eventService.config.showVehicleSelector" />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line [title]="'Seleccionar Vehículos'"
    [description]="'Elige los vehículos que deseas filtrar en la tabla de eventos.'" [filterBy]="filterOptionsBy">
    <p-multiSelect [options]="vehiclesList" [appendTo]="'body'" optionLabel="name" [showToggleAll]="true"
      [(ngModel)]="eventService.config.vehiclesSelected" [placeholder]="'EVENTS.LABELS.SELECT_VEHICLES' | translate"
      [selectedItemsLabel]="'{0} ' + ('EVENTS.LABELS.SELECTED_VEHICLES' | translate)" [filter]="true"
      [maxSelectedLabels]="1" filterBy="plate_number,cod_interno,name">
    </p-multiSelect>
  </app-config-line>


  <!-- ================= FILTRO DE ESTADO ================= -->
  <app-config-line [title]="'Seleccionar el estado del evento'"
    [description]="'Elige el estado que deseas filtrar en la tabla de eventos.'" [filterBy]="filterOptionsBy">
    <p-dropdown [options]="stateOptions" optionLabel="name" optionValue="value"
      [(ngModel)]="eventService.config.selectedState" [appendTo]="'body'" [placeholder]="'Seleccione un estado'"
      styleClass="w-full">
    </p-dropdown>
  </app-config-line>



   <!-- ================= IDENTIFICADOR DE CONDUCTORES ================= -->
  <ng-container *appHasPermission="'validate_event_driver'">
    <app-config-line
      [title]="'Identificación de conductores'"
      [titleLevel]="6"
      [withAll]="true"
      [render]="!filterOptionsBy"
      [description]="'Permite identificar al conductor desde una lista en el panel de eventos, facilitando la selección y validación del conductor correcto para cada evento.'"
      >
    </app-config-line>

    <app-config-line
      [title]="'Activar identificación de conductores'"
      [description]="'Permite mostrar u ocultar las opciones para identificar a los conductores.'"
      [filterBy]="filterOptionsBy">
      <label class="custom-switch mb-0">
        <input type="checkbox" [(ngModel)]="eventService.config.enableDriverIdentification" />
        <span class="slider"></span>
      </label>
    </app-config-line>

    <app-config-line
      [title]="'Abrir panel de conductores automáticamente'"
      [description]="'Al abrir un evento desde el panel de eventos, se mostrará automáticamente el panel de conductores.'"
      [filterBy]="filterOptionsBy">
      <label class="custom-switch mb-0">
        <input type="checkbox" [(ngModel)]="eventService.config.autoOpenDriverPanel" />
        <span class="slider"></span>
      </label>
    </app-config-line>
  </ng-container>


  <!-- ================= COLUMNAS DE EVENTOS ================= -->
  <!-- <app-config-line
    [title]="'Columnas de eventos'"
    [description]="'.'"
    [filterBy]="filterConfiguration"
  >
    <p-multiSelect
      [options]="columnOptions"
      [(ngModel)]="selectedColumns"
      defaultLabel="Seleccionar Columnas"
      [showToggleAll]="false"
      [appendTo]="'body'"
      [selectedItemsLabel]="'{0} ' + 'columnas'"
      (onChange)="updateVisibleColumns()"
      [maxSelectedLabels]="2"
    ></p-multiSelect>
  </app-config-line> -->


</div>
